import urlToBase64 from "Common/componentUtils/urlToBase64";
import { documentObjectIconMap } from "Common/dictionaries/documentObjectIconId";
import map from "lodash/map";
import pickBy from "lodash/pickBy";
import size from "lodash/size";
export default async (iconIdBase64) => {
    const unloadedDocumentObjectIconMap = pickBy(documentObjectIconMap, (_, iconId) => !iconIdBase64[iconId]);
    if (!size(unloadedDocumentObjectIconMap))
        return;
    await Promise.all(map(unloadedDocumentObjectIconMap, async (src, iconId) => {
        await new Promise(resolve => {
            urlToBase64(src, async (res) => {
                iconIdBase64[iconId] = res ? res : "";
                resolve(res);
            });
        });
    }));
};
